import { Flex } from "theme-ui";
import { Header } from "../../layouts/Header";
import { WebAnalytics } from "../../components/SEO";
import "../../layouts/layout-base.css";
import {
  FindAStoreLayout as DefaultLayout,
  FindAStoreLayoutProps,
} from "cobra-find-a-store/src/layouts/FindAStoreLayout";
import { useEffect, useState } from "react";

export const FindAStoreLayout = (props: FindAStoreLayoutProps) => {
  const [onLoad, setOnLoad] = useState(false);
  useEffect(() => {
    setOnLoad(true);
  }, []);

  return (
    <>
      {onLoad && (
        <link
          href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          rel="stylesheet"
        />
      )}
      <Flex
        className={props.className}
        sx={{
          bg: "grays.0",
          flexDirection: "column",
          fontFamily: "body",
          position: "relative",
          height: "100%",
          minHeight: "100%",
          width: "100%",
          display: "flex",
        }}
      >
        <Header
          sx={{
            top: 0,
            width: "100%",
            position: "sticky",
            zIndex: 10,
          }}
        />
        <DefaultLayout {...props} />
        <WebAnalytics />
      </Flex>
    </>
  );
};
export default FindAStoreLayout;
